import $ from "jquery";

var $window = $(window),
  pathname = window.location.pathname,
  layouts = ["/urheilu", "/ohjelmakirjastot"],
  History;

function emulatedPushState(data, title, url) {
  if (title) {
    document.title = title;
  }
  if (url[0] !== "/") {
    url = "/" + url;
  }
  var layout = findLayout(url);
  var hash = escapeHash(layout.length > 1 ? url.substring(layout.length) : url);
  if (History.getState().url !== url) {
    window.location.href = layout + "#!" + hash;
  }
}

function findLayout(url) {
  var item = "/",
    found = layouts.some(function (layout) {
      item = layout;
      return url.indexOf(layout) === 0;
    });
  return found ? item : "/";
}

function hasHashUrl() {
  return window.location.hash.substring(0, 3) === "#!/";
}

var supportPushState = typeof window.history.pushState !== "undefined";

if (supportPushState) {
  window.onpopstate = function () {
    $window.trigger("statechange");
  };
}

function hashChange() {
  var hash = window.location.hash;
  if (hasHashUrl()) {
    pathname = (layouts.indexOf(window.location.pathname) !== -1 ? window.location.pathname : "") + hash.substring(2);
    if (supportPushState) {
      History.replaceState(null, null, pathname);
    }
    $window.trigger("statechange");
  } else if (!supportPushState) {
    pathname = window.location.pathname;
    $window.trigger("statechange");
  }
}

window.addEventListener("hashchange", hashChange, false);

function startup(request) {
  if (supportPushState && hasHashUrl()) {
    History.replaceState(null, null, window.location.hash.substring(2));
  }

  if (!supportPushState && request && !hasHashUrl() && window.location.pathname.length > 1 && request.route.callback) {
    emulatedPushState(null, null, window.location.pathname);
  }

  if (!supportPushState && (hasHashUrl() || request.route.callback)) {
    hashChange();
  }
}

function escapeHash(hash) {
  var result = window.encodeURIComponent(hash);
  result = result.replace(/%2F/g, "/");
  result = result.replace(/%2C/g, ",");
  return result;
}

History = {
  pushState: function (data, title, url) {
    if (supportPushState) {
      window.history.pushState(data, title, url);
      $window.trigger("statechange");
    } else {
      emulatedPushState(data, title, url);
    }
  },
  replaceState: function (data, title, url) {
    if (supportPushState) {
      window.history.replaceState(data, title, url);
      $window.trigger("statechange");
    }
  },
  getState: function () {
    pathname = pathname.replace(/\/\//g, "/");
    return {
      pathname: supportPushState ? window.location.pathname : pathname
    };
  },
  startup: startup,
  emulated: !supportPushState
};

if (hasHashUrl()) {
  pathname = window.location.pathname + window.location.hash.substring(2);
}

export default History;



// WEBPACK FOOTER //
// ./web/js/pushstate.js